module.exports = __webpack_public_path__ + "static/img/scg.66b22c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scg.jpg
// module id = wPcV
// module chunks = 0